import { render, staticRenderFns } from "./MaterialEditingRecord.vue?vue&type=template&id=427e6fdc&scoped=true"
import script from "./MaterialEditingRecord.vue?vue&type=script&lang=js"
export * from "./MaterialEditingRecord.vue?vue&type=script&lang=js"
import style0 from "./MaterialEditingRecord.vue?vue&type=style&index=0&id=427e6fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e6fdc",
  null
  
)

export default component.exports